<style>

.bg{
  position: fixed;
  z-index: -1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  background-image: linear-gradient( rgba(255,255,255,0.7), rgba(255,255,255,0.7) ), url("/i/events-filter.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.card{
  color: black;
  padding: 50px 20px 20px 20px;
}

h4{
  margin: 20px 0 10px 0;
  font-size: 18px;
  font-style: italic;
  font-weight: normal;
}
.slider{
  display: grid;
  grid-template-columns: 68% auto;
  height: 35px;
}
.the-slider{
  grid-column: 1;
}
.slider-text{
  grid-column: 2;
  text-align: left;
  font-style: italic;
  font-size: 18px;
  margin: 1px 0 0 20px;
}

:global(#distance){
  --handle-focus: gray;
  --handle-inactive: gray;
  margin: 7px 0;
}
:global(#price){
  --handle-focus: gray;
  --handle-inactive: gray;
  margin: 7px 0;
}
.rangeSlider .rangeHandle.active .rangeNub{
  background-color: black;
}
.rangeHandle .rangeNub {
  border: 3px solid black;
}
.search{
  margin: 10px 0;
  text-align: center;
  font-style: italic;
}

.calendar-buttons{
  text-align: center;
  margin-top: 20px;
}
button{
  width: auto;
  border: none;
  color: white;
  background-color: black;
  border-radius: 28px;
  font-size: 18px;
  font-weight: bold;
  padding: 10px 20px;
}
.matters-not{
  font-size: 16px;
}
</style>

<Header back="{true}" white="{true}" on:back="{ () => pop() }">Filter</Header>
<!-- <div class="has-header"></div> -->

<div class="bg"></div>

<div class="card">
  
  <CheckList></CheckList>
  
  <h4>Distance Away</h4>
  <div class="slider">
    <div class="the-slider">
      <RangeSlider id="distance" min="{2}" max="{80}" bind:values="{distance}" springValues="{ { stiffness: 0.25, damping: 0.9 } }"></RangeSlider>
    </div>
    <div class="slider-text">
      {distance[0]} miles
    </div>
  </div>

  <h4>Price</h4>
  <div class="slider">
    <div class="the-slider">
      <RangeSlider id="price" min="{0}" max="{50}" bind:values="{price}" springValues="{ { stiffness: 0.25, damping: 0.9 } }"></RangeSlider>
    </div>
    <div class="slider-text">
      {#if price[0] > 0}
        ${price[0]}
      {:else}
        <div class="matters-not">Doesn't Matter</div>
      {/if}
    </div>
  </div>
  
  <h4>Date</h4>
  <!-- <div class="search">Search: May 10 to May 14</div> -->
  <div class="search"> </div>
  <Calendar bind:date="{date}"></Calendar>

  <div class="calendar-buttons">
    <button on:click="{ () => {date = todayStr} }">Today</button>
    <button on:click="{ () => {date = tomorrowStr} }">Tomorrow</button>
  </div>
  
</div>


<script>

import {push, pop, replace, location} from 'svelte-spa-router';

import Header from "../components/Header.svelte";
import CheckList from "../components/CheckList.svelte";
import Calendar from "../components/Calendar.svelte";
import RangeSlider from "svelte-range-slider-pips";

let distance = [2];
let price = [10];
let date = "2024-02-29";
let today = new Date();
let todayStr = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();

today.setDate(today.getDate() + 1);
let tomorrowStr = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();

</script>